import { useEffect } from "react";
import Header from "../../components/StudentPortal/Header/Header";
import QuizComponent from "../../components/StudentPortal/Quiz/Quiz";

export default function Quiz() {
  useEffect(() => {
    document.title = "Quize - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <QuizComponent />
    </>
  );
}
